import api from '../lib/api';

const API_URL =
  process.env.NEXT_PUBLIC_API_URL || 'http://localhost:4000/rest-api';

export const tokenValidationService = {
  async validateToken(token: string) {
    try {
      const response = await api.post(
        `${API_URL}/temporary-users/validate-token`,
        {
          token,
        }
      );
      return response.data;
    } catch (error) {
      console.error('Token validation failed:', error);
      return { isValid: false, reason: 'validation_error' };
    }
  },

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async checkSessionValidity(session: any) {
    if (!session?.isTemporaryUser || !session?.accessToken) {
      return { isValid: true }; // Not a temporary user or no token
    }

    // For temporary users, check with backend
    return this.validateToken(session.accessToken);
  },
};
